import { Component, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { CoreLibModalComponent } from '../modal/modal.component';
import { DialogRef } from '../modal/dialog-ref';
import { DIALOG_DATA } from '../modal/dialog-tokens';
import { CaseDiscardModalComponent } from '../case-detail-modal/case-discard-modal/case-discard-modal.component';
import { UtilService } from 'app/shared/util.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mh-core-lib-bags-modal',
  templateUrl: './bags-modal.component.html',
  styleUrls: ['./bags-modal.component.scss'],
  standalone: false,
})
export class CoreLibBagsModalComponent extends CoreLibModalComponent implements OnInit {
  coverageEmailStatus = '';
  coveragePhoneStatus = '';
  customImproveText: string = '';
  customTitle: string = '';
  customDescription: string = '';
  customOptionsDescription: string = '';
  tooltipDescription: string = '';
  tooltipHighlight: string = '';
  coverage: number;
  showWarnMessage: boolean = false;
  showBackButton: boolean = false;
  utilService = inject(UtilService);
  isSuperAdmin: boolean;
  @ViewChild('listBags') listBags: CaseDiscardModalComponent;
  options: any[] = [];
  limit: any;
  constructor(
    protected dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public data: any,
    private translateService: TranslateService,
  ) {
    super(dialogRef, data);
  }

  ngOnInit(): void {
    this.customTitle = this.data?.customTitle || 'followup.summary.data-rate.bags_modal.title';
    this.customDescription = this.data?.customDescription || '';
    this.tooltipDescription = this.data?.tooltipDescription || '';
    this.tooltipHighlight = this.data?.tooltipHighlight || '';
    this.options = this.data?.options || [];
    this.limit = this.data?.limit || 0;
    this.showBackButton = this.data?.showBackButton || false;
    this.isSuperAdmin = this.utilService.currentUser.superAdmin;
    this.customDescription =
      this.data?.customDescription ||
      this.translateService.instant('followup.summary.data-rate.bags_modal.limit_text', {
        count: this.limit,
      });
    this.customOptionsDescription =
      this.data?.customOptionsDescription ||
      this.translateService.instant('followup.summary.data-rate.bags_modal.description');
  }

  initDefaultTableData(): void {}

  isCoverageValid(coverage: number): boolean {
    return coverage >= 50;
  }

  sendSelectedBag() {
    this.dialogRef.close(this.selectedBag);
  }

  goBack() {
    this.dialogRef.close('back');
  }

  getKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  get status() {
    return this.data.classes.state.replace('_', '-');
  }

  get type() {
    return this.data.type;
  }

  get tooltipTranslate() {
    return this.data.tooltipTranslate;
  }

  get currentDateFilter() {
    return this.data.currentFilter.label;
  }

  get validEmailPercentage() {
    return this.data.validEmailPercentage;
  }

  get guestsWithValidEmail() {
    return this.data.guestsWithValidEmail;
  }

  get totalGuests() {
    return this.data.totalGuests;
  }

  get emailsCount() {
    return this.data.emailsCount;
  }

  get selectedBag() {
    return this.listBags?.currentOption;
  }

  get isAdmin() {
    return (
      (this.utilService.currentUser.isAdmin() ||
        this.utilService.currentUser.user_role.toLowerCase() === 'administrator') &&
      !this.isSuperAdmin
    );
  }
}
